

/*
 * API base URL is set by REACT_APP_ENV_URL.
 * For local testing: create bisharat-family-ui/.env.local with:
 *   REACT_APP_ENV_URL=http://localhost:8080
 * (Replace 8080 with your backend port if different.)
 */
export const ENV_URL =
  process.env.REACT_APP_ENV_URL || "https://bisharatfamily.com";
